module.exports = __webpack_public_path__ + "img/kontakt-hinzufugen.a3a1be0f.png";